import classes from "./MainNavigation.module.css";

const Footer = () => {
  return <footer className={classes.header}></footer>;
};

export default Footer;
